// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import {
  RescheduleKontaktaufnahmeRequest,
  type SuccessResponse,
} from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useRescheduleKontaktaufnahme(): (
  kontaktaufnahmeId: string,
  requestBody?: RescheduleKontaktaufnahmeRequest
) => Promise<SuccessResponse> {
  const getAPI = useGetApi();
  return useCallback(
    async (kontaktaufnahmeId, requestBody) =>
      (await getAPI()).kontaktaufnahme.rescheduleKontaktaufnahme({
        kontaktaufnahmeId,
        requestBody,
      }),
    [getAPI]
  );
}
